// AuthLayout — shell for public auth pages (login, complete-profile).
// Navy header bar with brand, centered white card on a light background.
import { Outlet } from "react-router-dom";

export default function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      <header className="bg-dm-navy px-6 py-4">
        <p className="font-display text-lg font-semibold tracking-wide text-white">
          Daniels Mediation <span className="text-dm-gold">&amp; ADR</span>
        </p>
      </header>

      <main className="flex flex-1 items-center justify-center p-6">
        <div className="w-full max-w-[400px] rounded-lg bg-white p-8 shadow-lg">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
